<template>
  <div class="footerBox">
   <div class="footBanner">
    <div class="left">
      <ul>
        <li>
          <div class="text">
            <p class="workType">{{$t("footer.title1")}}</p>
            <p class="roleName">{{$t("footer.per1")}}</p>
            <p class="qq">QQ:331291204</p>
          </div>
          <div class="img">
            <img src="@/assets/images/cui.png" alt="">
          </div>
        </li>
        <!--<li class="ml60">-->
          <!--<div class="text">-->
            <!--<p class="workType">{{$t("footer.title2")}}</p>-->
            <!--<p class="roleName">{{$t("footer.per2")}}</p>-->
            <!--<p class="qq">QQ:719459791</p>-->
          <!--</div>-->
          <!--<div class="img">-->
            <!--<img src="@/assets/images/wang.png" alt="">-->
          <!--</div>-->
        <!--</li>-->
      </ul>
    </div>
    <div class="right">
      <p style="margin-top:-6px;">© Copyright 2019 星辰品阅 All Rights Reserved  <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备11012669号-37</a></p>
    </div>
   </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data(){
    return{
      lang:this.$i18n.locale,
    }
  }
};
</script>
<style lang="scss">
.footerBox {
  width:100%;
  min-width: 1300px;
  height:270px;
  background:linear-gradient(135deg,rgba(54,190,250,1) 0%,rgba(18,121,219,1) 100%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  z-index:10;
  .footBanner{
    width: 1300px;
    margin:0 auto;
    display:flex;
    flex-direction:row;
    /* align-items:center; */
    justify-content:center;
    .left{
      margin-right: 50px;
      ul{
        display: flex;
        flex-direction:row;
        li{
          display: flex;
          flex-direction:row;
          color:rgba(255,255,255,1);
          font-size:16px;
          font-family:PingFangSC-Regular,PingFang SC;
          .text{
            display: flex;
            flex-direction:column;
            justify-content:center;
            .workType{
              font-size:30px;
              font-family:YouSheBiaoTiHei;
              text-shadow:0px 2px 2px rgba(0,114,179,0.5);
            }
            .roleName{
              margin-top: 18px;
            }
            .qq{
              margin-top: 8px;
            }
          }
          img{
            width:102px;
            height:102px;
            margin-left: 32px;
          }
        }
      }
    }
    .right{
      color: #fff;
      font-size:16px;
      font-family:PingFangSC-Regular,PingFang SC;
      display: flex;
      flex-direction:column;
      justify-content: center;
      
      ul{
        display: flex;
        flex-direction:row;
        justify-content:space-between;
        li{
          /* margin-left: 30px; */
          a{
            color: #fff;
            font-size:16px;
          }
          
        }
      }
      .spaceRight{
        margin-top: 8px;
        justify-content:flex-end;
        li{
          padding-left: 40px ;
        }
      }
      p{
        margin-top: 20px;
        text-align: end;
        /* padding-right: 30px; */
        opacity: 0.5;
        a{
          color: #fff;
        }
      }
    }
  }
}
</style>
